export const sortByKey = (data, key) => {
  return data.sort((a, b) => {
    if (key === 'dateTime' || key === 'transDateTime' || key === 'modifyDate') {
      return new Date(a[key]) - new Date(b[key]);
    }

    return a[key] - b[key];
  });
};
